export default __webpack_public_path__ + "static/media/loginlogo.dfc2d0ea.png";